import { useCallback } from "react";
import { IReportCompanies, ILurikProcess } from "../../application/models";
import { useAxiosInstances } from "../axios-instance";

export const useReportCompaniesApi = () => {
  const { axiosAuthInstance } = useAxiosInstances();

  const getPeriodReportCompaniesApi = useCallback(
    async (data: {
      userId: string;
      limit?: number;
      page?: number;
      filters?: {
        name?: string;
        companyId?: string;
        vendedor?: string;
        startDate?: Date;
        endDate?: Date;
      };
    }): Promise<ILurikProcess> => {
      try {
        const result = await axiosAuthInstance.get(
          `/routes/report-companies/period/${data.userId}`,
          {
            params: {
              userId: data.userId,
              limit: data.limit,
              page: data.page,
              name: data.filters?.name,
              companyId: data.filters?.companyId,
              vendedor: data.filters?.vendedor,
              startDate: data.filters?.startDate,
              endDate: data.filters?.endDate,
            },
          }
        );
        if (result) {
          return result.data.result.iLurikProcess;
        } else {
          throw new Error("No result");
        }
      } catch (err) {
        throw err;
      }
    },
    [axiosAuthInstance]
  );

  const getStatusReportApi = useCallback(
    async (data: {
      userId: string;
      resourceId: string;
      idProcess: string;
    }): Promise<{
      reportCompanies: IReportCompanies[];
      idJsonFile: string;
      total: number;
      page: number;
      limit: number;
    } | null> => {
      // Permite retornar null
      try {
        const result = await axiosAuthInstance.get(
          `/routes/report-companies/status/${data.userId}`,
          {
            params: {
              userId: data.userId,
              resourceId: data.resourceId,
              idProcess: data.idProcess,
            },
          }
        );
        if (result.data?.result) {
          return result.data.result;
        }
        return null;
      } catch (err) {
        throw err;
      }
    },
    [axiosAuthInstance]
  );

  // const downLoadReportCompaniesApi = useCallback(
  //   async (data: {
  //     userId: string; 
  //     idProcess: string;
  //     idJsonFile: string;
  //   }): Promise<boolean> => {
  //     try {
  //       const result = await axiosAuthInstance.get(
  //         `/routes/report-companies/download/${data.userId}`,
  //         {
  //           params: {
  //             userId: data.userId,
  //             idProcess: data.idProcess,
  //             idJsonFile: data.idJsonFile,
  //           }
  //         }
  //       );
  //       if (result.data?.result === true) {
  //         return true;
  //       }
  //     } catch  {
  //       return false;
  //     }
  //     return false;
  //   },
  //   [axiosAuthInstance]
  // );

  return {
    getPeriodReportCompaniesApi,
    getStatusReportApi,
    //downLoadReportCompaniesApi,
  };
};